import "./Task.scss";

export const taskStyles = {
  root: "im-task",
  content: "im-task__content",
  buttons: "im-task__buttons",
  buttonsRow: "im-task__buttons-row",
  footer: "im-task__footer",
  withBackgroundColor: "im-task--with-background-color",
};
